<template>
  <div id="productIntroduction" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">应用案例</div>
        <div class="subTitle">
          PKPM-CAE已在建筑、水电、核电、交通等关键领域实现实际工程应用，并将持续为多行业提供自主可控、高效可靠的仿真分析解决方案。
        </div>
      </div>
    </div>
    <div class="main">
        <div class="content">
          <div class="block" v-for="item in contentList">
            <div class="title">
              {{ item.name }}
            </div>
            <div class="zone">
              <div class="picZone">
                <img :src="item.uri" alt="" style="width: 100%">
              </div>
              <div class="textZone">
                {{item.description}}
              </div>
            </div>

          </div>

<!--          <div style="width: 100%" v-if="contentList.length!==0" v-for="(item,index) in contentList">-->
<!--            <div>-->
<!--              <img :src="item.uri" alt="" style="width: 100%;height: 100%">-->
<!--            </div>-->
<!--          </div>-->
        </div>
    </div>


  </div>


</template>

<script>
import axios from 'axios'
import {getCmsList, listCategory, searchFiles, listRelationFiles} from '../api/index'
import utils from '../lib/utils'

export default {
  name: "applyCase",
  data() {
    return {
      contentList: [],
    }
  },


  methods: {


    getContent() {
      searchFiles({
        type: 'case',
      }).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.contentList = res.data.result.cmsFiles
          // this.$set(this.imgList, 0, res.data.result.cmsFiles)
          if (this.contentList.length !== 0) {
            this.contentList.forEach((item, index) => {
              item.uri = utils.handleHttps(item.uri)
              item.imgUri = utils.handleHttps(item.imgUri)
              item.prog = 0
              item.showProg = false
            })
          }
          console.log(this.contentList)
        }
      }).catch((error) => {
        console.log(error);
      });
    },


  },
  mounted() {
    window.scrollTo(0, 0)
    this.getContent()
  }
}
</script>

<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/applyCase/caseBack.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}
.main{
  text-align: center;
  padding-top: 32px;
  padding-bottom: 36px;
  .content{
    padding:0 60px 60px 60px;
    display: inline-block;
    width: 1280px;
    background: white;
    .block{
      display: inline-block;
      margin-top: 60px;
      text-align: center;
      .title{
        width: 1160px;
        height: 50px;
        background: #F0F2F5;
        font-size: 20px;
        color: #333333;
        line-height: 50px;
      }
      .zone{
        height: 360px;
        margin-top: 40px;
      }
    }
    .block:nth-child(odd){
      .picZone{
        float: left;
        width: 600px;
        height: 360px;
        margin-right: 40px;
      }
      .textZone{
        height: 360px;
        float: left;
        width: 520px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        text-align: left;
        align-items: center;     /* 垂直居中 */
      }
    }
    .block:nth-child(even){
      .picZone{
        float: right;
        width: 600px;
        height: 360px;
        margin-left: 40px;
      }
      .textZone{
        height: 360px;
        float: left;
        width: 520px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        display: flex;
        text-align: left;
        align-items: center;     /* 垂直居中 */
      }
    }
  }
}


//.categories {
//  position: fixed;
//  display: inline-block;
//  width: 200px;
//  background-color: white;
//  border-radius: 2px;
//  padding: 25px;
//  margin-right: 15px;
//
//  .one {
//    margin-bottom: 25px;
//    font-size: 16px;
//    color: #333333;
//    font-weight: 800;
//    cursor: pointer;
//  }
//
//  .two {
//    margin-bottom: 25px;
//    font-size: 14px;
//    color: #666666;
//    font-weight: 500;
//    margin-left: 20px;
//    cursor: pointer;
//  }
//
//
//}
//
//.choseCate {
//  color: #1175EB !important;
//}
//
//.content {
//  display: flex;
//  width: 1200px;
//  margin: 0 auto;
//  min-height: 830px;
//  padding-bottom: 45px;
//  padding-top: 100px;
//
//  .block {
//    border-radius: 4px;
//    position: relative;
//    display: inline-block;
//    width: 300px;
//    border: 1px solid #EFEFEF;
//    margin: 0 10px 30px 15px;
//
//    &:hover {
//      box-shadow: 5px 5px 5px rgba(239, 239, 239, 1);
//      color: #1175EB;
//
//
//    }
//
//    .videoArea {
//      /*font-size: 20px;*/
//      /*line-height: 200px;*/
//      overflow-y: hidden;
//      height: 170px;
//      width: 300px;
//      cursor: pointer;
//    }
//
//    .textArea {
//      height: 50px;
//      background: #FFFFFF;
//      border-radius: 0 0 4px 4px;
//      padding: 15px;
//      width: 300px;
//
//      .cont {
//        display: inline-block;
//        width: 80%;
//        /*width: 100%;*/
//        white-space: nowrap;
//        overflow: hidden;
//        text-overflow: ellipsis;
//      }
//
//      .progClass {
//        bottom: 0;
//        left: 15px;
//        position: absolute;
//      }
//    }
//
//  }
//}
//
//@media (max-width: 1440px) {
//  .content {
//    width: 920px;
//  }
//  .categories {
//    left: 5px;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/applyCase.vue